import { TaskTypeEnum } from '__generatedTypes__/globalTypes'

export const TASK_TYPE_TITLE: Record<TaskTypeEnum, string> = {
  [TaskTypeEnum.PracticeTest]: 'Practice Test',
  [TaskTypeEnum.QBank]: 'QBank',
  [TaskTypeEnum.Resource]: 'Resource',
  [TaskTypeEnum.Video]: 'Video',
  [TaskTypeEnum.Custom]: 'Custom',
}
